module.exports = __webpack_public_path__ + "static/media/20.6b912f12.jpg";